export const cart = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Proceed to Checkout',
    cartName: 'Cart #{{code}}',
    itemsNotReserved: 'Items in cart are not reserved.',
    article: 'Article',
  },
  cartItems: {
    id: 'ID',
    description: 'Description',
    item: 'Item',
    itemPrice: 'Item Price',
    quantity: 'Quantity',
    quantityTitle: 'The quantity indicates the total number of the item in your cart.',
    total: 'Total',
    cartTotal: 'Your cart ({{count}})',
    cartTotal_plural: 'Your cart ({{count}})',
    speditionArticle: 'Freight Item',
    itemAddedToCart: 'Your item has been added to cart',
    personalisation: 'Personalization',
    personalised: 'personalized',
    fontStyle: 'Font Style',
    yourInput: 'Your Details',
    removeFromCart: 'Remove',
    itemCounterMinRestrition: 'The minimum number of items for a product is 1.',
    itemCounterMaxRestrition: 'The maximum number of items for this product is {{max}}.',
    soldOut: 'Sold Out',
    notifyMe: 'Notify Me',
    personalize: 'Personalize',
  },
  orderCost: {
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal after discounts:',
    shipping: 'Shipping:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'saved:',
    salesTax: 'VAT:',
    grossTax: 'The total order amount does not include the following tax amount:',
    grossIncludeTax: 'The total order amount includes taxes of',
    total: 'Total:',
    toBeDetermined: 'to be determined',
  },
  voucher: {
    coupon: 'Do you have a promotional code?',
    couponGiftcard: 'Do you have a gift card or promotional code?',
    coupon_plural: 'Gift cards or promotional codes',
    apply: 'Apply',
    placeholder: 'Promo code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    applyGiftcardSuccess: 'The voucher {{voucherCode}} has been added to the shopping cart.',
    anchorLabel: 'Enter or remove gift card/promotional code.',
    vouchersApplied: 'Applied gift cards/promotional codes',
    availableCoupons: 'Available promotional codes',
    availableCouponsLabel: 'You can add these promotional codes.',
    promotionError: {
      ERR01: 'The promotion has already ended.',
      ERR02: 'The promotional code is not yet valid.',
      ERR03: 'The promotional code is not valid.',
      ERR05: 'Your cart does not contain a product to which the promotion can be applied.',
      ERR06: 'The code you entered has already been redeemed and cannot be used again.',
      ERR07: 'The minimum order value for the promotion has not been reached.',
      ERR08: 'The promotion code is not valid.',
      ERR09: 'Due to the best price logic, some promotions cannot be redeemed at the same time.',
      ERR10: 'Shipping is free of charge, so the code you entered cannot be added.',
      ERR12: 'The voucher has already been redeemed.',
      ERR13:
        'Unfortunately, promotional codes cannot currently be redeemed for technical reasons. Please contact our customer service.',
      ERR14: 'The discount code cannot be applied to your cart.',
      ERR14WithDisclaimer:
        'The discount code cannot be applied to your cart. Please note the promotion conditions:<br>[Promotional code: {{voucherCode}}<br><br>{{disclaimer}}]',
    },
  },
  saveForLaterItems: {
    itemTotal: 'Saved for later ({{count}} item)',
    itemTotal_plural: 'Saved for later ({{count}} items)',
    cartTitle: 'Cart',
    yourCart: 'Your Cart',
    saveForLater: 'Saved for later',
    moveToCart: 'Move to Cart',
    stock: 'Stock',
    forceInStock: 'In Stock',
  },
};
